module.exports = __webpack_public_path__ + "img/marquee-kyroro.4d118cec.webp";